import AbDatePicker from './datePicker';
AbDatePicker.install = function(Vue) {
  Vue.component(AbDatePicker.name, AbDatePicker);
};
export default AbDatePicker;
